<template>
  <div id="solicitacaoAparelho">
    <v-form  @submit.prevent="goToEndereco">
    <div class="container-aparelho">
      <div class="label">Sugira um aparelho</div>
        <v-text-field
          class="label-solicitacao"
          required
          label="Marca"
          name="marca"
          autocomplete="off"
          maxlength="255"
          v-model="marca"
        />
        <v-text-field
          class="label-solicitacao"
          required
          label="Modelo"
          name="modelo"
          autocomplete="off"
          maxlength="255"
          v-model="modelo"
        />
        <v-text-field
          class="label-solicitacao"
          required
          label="Nome Completo"
          name="name"
          autocomplete="off"
          maxlength="255"
          v-show="!hideName"
          v-model="name"
          :rules="[(v) => /[a-zA-ZÀ-ÿ]{2,}\s[a-zA-ZÀ-ÿ]/.test(v) || 'Por favor, digite seu nome completo']"
        />
        <v-text-field
          class="label-solicitacao"
          required
          label="Email"
          name="email"
          autocomplete="off"
          maxlength="255"
          v-show="!hideEmail"
          v-model="email"
          :rules="[(v) => isEmailValid(v) || 'Por favor, digite um email válido']"
        />
        <v-text-field
          class="label-solicitacao"
          required
          label="Telefone"
          name="phone"
          autocomplete="off"
          maxlength="255"
          v-show="!hidePhone"
          v-model="phone"
          v-mask="['(##) #####-####', '(##) ####-####']"
          :rules="[(v) => v.length >= 14 || 'Por favor, digite um celular válido']"
        />
        <b-button class="cadastrar-solicitacao"
          pill
          block
          variant='danger'
          @click="postSucesso()"
          :disabled="!this.marca || !this.modelo || !this.name || !this.email || !this.phone">
          Sugerir
        </b-button>
      </div>
    </v-form>
  </div>
</template>

<script>
import './SolicitacaoAparelho.css'

import axios from 'axios'

export default {
  name: 'solicitacaoAparelho',
  data () {
    return {
      marca: '',
      modelo: '',
      hideName: false,
      hideEmail: false,
      hidePhone: false
    }
  },
  props: {
    name: String, // nome do lead
    email: String, // email do lead
    phone: String, // celular do lead
    typeDevice: String // tipo do produto
  },
  methods: {
    postSucesso () {
      let payload = {
        product: 'CELULAR',
        item: {
          manufacturer: this.marca,
          model: this.modelo,
          deviceType: this.typeDevice.name
        }
      }

      if (this.name) {
        payload.item.name = this.name
      }

      if (this.email) {
        payload.item.email = this.email
      }

      if (this.phone) {
        payload.item.phone = this.phone
      }

      axios
        .post(`${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/intentions`, payload, JSON.parse(sessionStorage.config))
        .then(() => {
          this.$bvModal.show('solicitacaoAparelhoSucesso')
          this.$bvModal.hide('solicitacaoAparelho')
        })
        .catch(error => {
          this.$sentry.logWithContext({
            ctx: { step: '[device request]' }, error
          })
        })
    },
    isEmailValid (email) {
      let regex = /^[\w.-]+@[a-zA-Z]+?\.[a-zA-Z]{2,3}\.{0,1}[a-zA-Z]{1,2}$/
      return regex.test(email)
    }
  },
  async mounted () {
    if (this.email) {
      this.hideName = true
    }
    if (this.email) {
      this.hideEmail = true
    }
    if (this.phone) {
      this.hidePhone = true
    }
  },
  computed: {
    isDeviceProject () {
      return process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis'
    }
  }
}
</script>
